export const mapValueToRange = (value: number, minValue: number, maxValue: number, targetMin: number, targetMax: number) => {
    value = Math.min(Math.max(value, minValue), maxValue);

    const mappedValue = ((value - minValue) / (maxValue - minValue)) * (targetMax - targetMin) + targetMin;

    return mappedValue;
}